/**
 * Helpers for properties.
 */

/**
 * Define a new property.
 *
 * Usage example:
 *
 * defineProperty(self, 'myNewProperty'
 *     function () {
 *         return 42;
 *     },
 *     function (value) {
 *         console.log('You tried to set the property to ' + value + '. That is not OK.');
 *     }
 * );
 *
 * @param obj Object to define property on.
 * @param propertyName Name of property.
 * @param getter Gettet method.
 * @param [setter] Optional setter method.
 * @param [options] Optional extra options dictionary.
 */
window.defineProperty = function (obj, propertyName, getter, setter, options) {
    var properties = {};

    if (getter) {
        properties['get'] = getter;
    }
    if (setter) {
        properties['set'] = setter;
    }
    if (options) {
        _.assign(properties, options);
    }

    return Object.defineProperty(obj, propertyName, properties);
};
